module["exports"] = ["주식회사", "한국"];